import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import CompanyName from '../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import Decision from '../../commonComponents/Decision';
import { DecisionType } from '../../../static/types/commonTypes/decisionType';
import LegalEntity from '../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import LeaderChange from '../../commonComponents/LeaderChange';
import { LeaderChangeType } from '../../../static/types/commonTypes/leaderChangeType';
import ManagerListWithRepresentative from './limited-company-creation/ManagerListWithRepresentative';
import ReducedManagerList from '../../commonComponents/ReducedManagerList';
import { changes } from '../../../constant/company-modification/changes';
import { functions } from '../../../constant/company-modification/functions';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import { ManagerWithRepresentativeType } from '../../../static/types/limited-company-creation/managerWithRepresentativeType';
import { ReducedManagerType } from '../../../static/types/commonTypes/reducedManagerType';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import DecisionWithQuality from '../../commonComponents/DecisionWithQuality';
import { formatObjectText } from '../../../utils/functions/formatObjectText';


interface AnnonceProps {
    onValidate: (isValid: boolean) => void;
    txtAnnonce: string;
    denomination: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const ModificationDirigeant: React.FC<AnnonceProps> = ({
    onValidate,
    txtAnnonce,
    denomination,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType
}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        decisionWithQualityAndEffectiveDate,
        setDecisionWithQualityAndEffectiveDate,
        decisionWithQualityAndEffectiveDateValidity,
        setDecisionWithQualityAndEffectiveDateValidity,
        decisionWithQualityAndEffectiveDateChecked,
        setDecisionWithQualityAndEffectiveDateChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,


        leaderChange, setLeaderChange,
        leaderChangeValidity, setLeaderChangeValidity,
        leaderChangeChecked, setLeaderChangeChecked,

        managersWithRepresentativeList, setManagersWithRepresentativeList,
        managersWithRepresentativeListValidity, setManagersWithRepresentativeListValidity,
        managersWithRepresentativeListChecked, setManagersWithRepresentativeListChecked,

        reducedManagers, setReducedManagers,
        reducedManagersValidity, setReducedManagersValidity,
        reducedManagersChecked, setReducedManagersChecked,

        lastTab, setLastTab

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [submissive, setSubmissive] = useState(false)
    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];


    const validate = () => {

        if (!companyNameValidity) setActiveTab('companyName')
        else if (!decisionWithQualityAndEffectiveDateValidity) setActiveTab('decision')
        else if (!legalEntityValidity) setActiveTab('theSociety')
        else if (!leaderChangeValidity) setActiveTab('leaderChange')
        else if (["Nomination sans départ", "Départ avec remplacement"].includes(leaderChange.change) && !managersWithRepresentativeListValidity) setActiveTab('arriving')
        else if (["Départ sans remplacement", "Départ avec remplacement"].includes(leaderChange.change) && !reducedManagersValidity) setActiveTab('leaving')

        const arrivingValidity = ["Nomination sans départ", "Départ avec remplacement"].includes(leaderChange.change) ? managersWithRepresentativeListValidity : true

        const leavingValidity = ["Départ sans remplacement", "Départ avec remplacement"].includes(leaderChange.change) ? reducedManagersValidity : true

        return companyNameValidity && decisionWithQualityAndEffectiveDateValidity && legalEntityValidity && leaderChangeValidity && arrivingValidity && leavingValidity
    };


    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {
            const pluralSubjects = ["Les associés","Les actionnaires"];

            const verb = pluralSubjects.includes(decisionWithQualityAndEffectiveDate.decisionQuality) ? "ont" : "a";
            const decisionNature = decisionWithQualityAndEffectiveDate.decisionNature === "AG Extraordinaire"
                ? "l'AGE"
                : decisionWithQualityAndEffectiveDate.decisionNature === "AG Ordinaire"
                    ? "l'AGO"
                    : decisionWithQualityAndEffectiveDate.decisionNature === "AG Mixte"
                        ? "l'AG Mixte"
                        : decisionWithQualityAndEffectiveDate.decisionNature

            const decisionText = firstPartDecision.includes(decisionWithQualityAndEffectiveDate.decisionNature)
                ? `Aux termes de ${decisionNature} en date du ${decisionWithQualityAndEffectiveDate.decisionDate} ${decisionWithQualityAndEffectiveDate.decisionQuality} ${verb} ${decisionWithQualityAndEffectiveDate.effectiveDate ? `` : ``}`
                : `Le ${decisionWithQualityAndEffectiveDate.decisionDate}, ${decisionNature.toLowerCase()} ${decisionWithQualityAndEffectiveDate.effectiveDate ? `${verb}` : ``}`


            const managerWithRepresentativeText = (manager: ManagerWithRepresentativeType): string => {
                if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}`
                }
                else if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)} représentée par ${manager.entityDetails.civility === "Monsieur" ? "M. " : "Mme "} ${manager.entityDetails.lastName} ${manager.entityDetails.firstName}`
                }
                else return ''
            }

            const reducedManagerText = (manager: ReducedManagerType): string => {
                if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}`
                }
                else if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}`
                }
                else return ''
            }

            const leaderText = ( leaderchangeItem: LeaderChangeType ) => {
                
                if( leaderchangeItem.change === "Nomination sans départ" ){
                    return `${decisionText} nommé ${ managersWithRepresentativeList.length > 1 ? functions.find(( functionItem: { plural: string, singular: string } ) => functionItem.singular === leaderChange.function )?.plural : leaderChange.function } ${ managersWithRepresentativeList.map( managerItem => managerWithRepresentativeText( managerItem ))} à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}`
                }
                else if (leaderchangeItem.change === "Départ sans remplacement") {
                    return `${decisionText} pris acte de la démission des fonctions de ${managersWithRepresentativeList.length > 1 ? functions.find((functionItem: { plural: string, singular: string }) => functionItem.singular === leaderChange.function)?.plural : leaderChange.function} de ${reducedManagers.map(managerItem => reducedManagerText(managerItem))} à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}`
                }
                else if (leaderchangeItem.change === "Départ avec remplacement") {
                    return `${decisionText} nommé ${managersWithRepresentativeList.length > 1 ? functions.find((functionItem: { plural: string, singular: string }) => functionItem.singular === leaderChange.function)?.plural : leaderChange.function} ${managersWithRepresentativeList.map(managerItem => managerWithRepresentativeText(managerItem))} en remplacement de ${reducedManagers.map(managerItem => reducedManagerText(managerItem))} à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}`
                }
            }

            const tempText = `${legalEntity.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €,
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)}
${leaderText(leaderChange)},
Mention au RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            setSubmissive(true)
            updateDenomination(companyName.companyName)
        }
        else setSubmissive(false)
    }

    const handleNext = () => {
        if (activeTab === "companyName") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === "decision") {
            setDecisionWithQualityAndEffectiveDateChecked(true)
            if (decisionWithQualityAndEffectiveDateValidity) {
                switchTab(getNextTab("decision"));
            }
        } else if (activeTab === "theSociety") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("theSociety"));
            }
        } else if (activeTab === "leaderChange") {
            setLeaderChangeChecked(true)
            if (leaderChangeValidity) {
                switchTab(getNextTab("leaderChange"));
            }
        } else if (activeTab === "arriving") {
            setManagersWithRepresentativeListChecked(true)
            if (leaderChange.change === "Nomination sans départ") {
                if (managersWithRepresentativeListValidity) {
                    setSubmissive(true)
                }
            }
            else if (leaderChange.change === "Départ avec remplacement") {
                if (managersWithRepresentativeListValidity) {
                    switchTab(getNextTab("arriving"));
                }
            }
        } else if (activeTab === "leaving") {
            setReducedManagersChecked(true)
            if (reducedManagersValidity) {
                setSubmissive(true)
            }
        }
    };

    const goToSupportPresse = () => updateActiveIndex(2)

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };


    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['companyName', 'decision', 'theSociety', 'leaderChange', 'arriving', 'leaving'];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    const getNextTab = (currentTab: string) => {
        if (currentTab === 'companyName') return 'decision';
        else if (currentTab === 'decision') return 'theSociety';
        else if (currentTab === 'theSociety') return 'leaderChange';
        else if (currentTab === 'leaderChange') {
            if (["Nomination sans départ", "Départ avec remplacement"].includes(leaderChange.change)) return 'arriving'
            else return 'leaving'
        }
        else if( currentTab === 'arriving' && leaderChange.change === "Départ avec remplacement" ) return 'leaving'
        else return currentTab;
    }

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === 'decision') return 'companyName';
        else if (currentTab === 'theSociety') return 'decision';
        else if (currentTab === 'leaderChange') return 'theSociety';
        else if (currentTab === 'arriving') return 'leaderChange';
        else if (currentTab === 'leaving') {
            if (["Nomination sans départ", "Départ avec remplacement"].includes(leaderChange.change)) return 'arriving'
            else return 'leaderChange'
        }

        else return currentTab;
    };

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQualityAndEffectiveDate({ ...decisionWithQualityAndEffectiveDate, ...data });

const tabs = [
  { key: 'companyName', label: 'Raison Sociale' },
  { key: 'decision', label: 'La décision' },
  { key: 'theSociety', label: 'La société' },
  { key: 'leaderChange', label: 'Modification de dirigeant' },
];

if (leaderChange.change === 'Nomination sans départ') {
  tabs.push({ key: 'arriving', label: 'Arrivant' });
} else if (leaderChange.change === 'Départ sans remplacement') {
  tabs.push({ key: 'leaving', label: 'Partant' });
} else if (leaderChange.change) {
  tabs.push(
    { key: 'arriving', label: 'Arrivant' },
    { key: 'leaving', label: 'Partant' }
  );
}

return (
  <>
    <div className="container my-3">
      <ul className="nav nav-underline">
        {tabs
          .filter((tab) => tab.key === activeTab)
          .map((tab) => (
            <li className="nav-item" key={tab.key}>
              <a
                href={`#${tab.key}`}
                className="nav-link active"
                onClick={() => switchTab(tab.key)}
              >
                {tab.label}
              </a>
            </li>
          ))}
      </ul>
    </div>

           <ToastContainer />

            <form onSubmit={handleSubmit}>
                {/* raison sociale */}
                {
                    activeTab === 'companyName' &&
                    <CompanyName
                        changeCompanyName={(partialCompanyName: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialCompanyName })}
                        checked={companyNameChecked}
                        companyName={companyName}
                        onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                    />
                }

                {
                    activeTab === 'decision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQualityAndEffectiveDate}
                        draftFieldName = 'decisionWithQualityAndEffectiveDate'
                        checked={decisionWithQualityAndEffectiveDateChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityAndEffectiveDateValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'theSociety' &&
                    <LegalEntity
                        changeLegalEntity={(partialLegalEntity: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...partialLegalEntity })}
                        legalEntity={legalEntity}
                        societyType={societyTypeOptions}
                        checked={legalEntityChecked}
                        onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                        companyName={companyName}
                        setCompanyName={(partialCompanyName: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialCompanyName })}
                        draftFieldName = 'legalEntity'
                    />
                }

                {
                    activeTab === 'leaderChange' &&
                    <LeaderChange
                        changes={changes}
                        checked={leaderChangeChecked}
                        functions={
                            functions.map((functionItem: { [key: string]: string }) => functionItem.singular)
                        }
                        leaderChange={leaderChange}
                        onValidationChange={(isValid: boolean) => setLeaderChangeValidity(isValid)}
                        updateLeaderChange={(partialLeaderChange: Partial<LeaderChangeType>) => setLeaderChange({ ...leaderChange, ...partialLeaderChange })}
                    />
                }

                {
                    activeTab === 'arriving' &&
                    <ManagerListWithRepresentative
                        managers={managersWithRepresentativeList}
                        addButtonText='Ajouter un arrivant'
                        removeButtonText='Supprimer le dernier arrivant'
                        checked={managersWithRepresentativeListChecked}
                        representativeLabel='Représentée par :'
                        setManagers={setManagersWithRepresentativeList}
                        setManagersValidity={setManagersWithRepresentativeListValidity}
                        societyTypeOptions={societyTypeOptions}
                        draftFieldName = 'managersWithRepresentativeList'
                    />
                }

                {
                    activeTab === 'leaving' &&
                    <ReducedManagerList
                        addButtonText='Ajouter un partant'
                        removeButtonText='Supprimer le dernier partant'
                        checked={reducedManagersChecked}
                        reducedManagers={reducedManagers}
                        setReducedManagers={setReducedManagers}
                        setReducedManagersValidity={setReducedManagersValidity}
                    />
                }

                {
                    submissive &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }


                <div className='button-container'>
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }

                        {
                            (
                                (activeTab === 'arriving' && leaderChange.change === "Nomination sans départ") ||
                                (activeTab === 'leaving' && ["Départ sans remplacement", "Départ avec remplacement"].includes(leaderChange.change))
                            )
                            &&
                            <button
                                type="submit"
                                onClick={handleNext}
                            >
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            !(
                                (activeTab === 'arriving' && leaderChange.change === "Nomination sans départ") ||
                                (activeTab === 'leaving' && ["Départ sans remplacement", "Départ avec remplacement"].includes(leaderChange.change))
                            )
                            &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext}
                            >
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                    </div>
                </div>

            </form>


        </>
    );
};

export default ModificationDirigeant;